import "./exportTsf.scss";

import PropTypes from "prop-types";
import PubSub from "pubsub-js";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import FormButton from "../../components/form/FormButton";
import FormCheckbox from "../../components/form/FormCheckbox";
import FormDropdown from "../../components/form/FormDropdown";
import ModalBody from "../../components/modal/ModalBody";
import ModalDescription from "../../components/modal/ModalDescription";
import ModalField from "../../components/modal/ModalField";
import ModalFooter from "../../components/modal/ModalFooter";
import ModalFooterRightGroup from "../../components/modal/ModalFooterRightGroup";
import ModalGroup from "../../components/modal/ModalGroup";
import ModalHeading from "../../components/modal/ModalHeading";
import ModalRow from "../../components/modal/ModalRow";
import ModalView from "../../components/modal/ModalView";
import PubSubTopics from "../../constants/pubSubTopics";
import skinOptions from "../../constants/skinOptions";
import { attachmentSelectors } from "../../modules/attachments";
import { preferencesSelectors } from "../../modules/preferences";
import { uiStateOperations } from "../../modules/uiState";
import { nativeCommsBroadcastMessageTypes } from "../../nativeComms";
import { exportTsfFile } from "../../nativeComms/nativeCommsReceiver.shared";

class ExportTsfModal extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      attachmentPath: null,
      disableFiltering: false,
      disableFilteringMore: false,
      disableSplitView: false,
      disableTimelineZoom: false,
      skin: this.props.skin
    };

    this.inputRef = React.createRef();
    this.onInputChange = this.onInputChange.bind(this);
    this.onExport = this.onExport.bind(this);
  }

  componentDidMount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.EXPORT_TSF_OPENED
    });
    this._pubSubEscapeKeyDownToken = PubSub.subscribe(PubSubTopics.escapeKeyDown, this.props.onCloseClick);
  }

  componentWillUnmount() {
    PubSub.publish(PubSubTopics.sendNativeMessage, {
      msg: nativeCommsBroadcastMessageTypes.EXPORT_TSF_CLOSED
    });
    PubSub.unsubscribe(this._pubSubEscapeKeyDownToken);
  }

  onInputChange() {
    const input = this.inputRef.current;
    this.setState({
      attachmentPath: input.value
    });
  }

  onExport() {
    this.props.onExportClick(
      this.state.attachmentPath,
      this.props.embeddedAttachments.toArray(),
      this.state.disableFiltering,
      this.state.disableFilteringMore,
      this.state.disableSplitView,
      this.state.disableTimelineZoom,
      this.state.skin
    );
  }

  render() {
    let modalHeading = (
      <ModalHeading
        title="Export to Timeline Standard Format"
        showCancel={true}
        onCancelClick={this.props.onCloseClick}
        showDone={true}
      />
    );
    let modalFooter = (
      <ModalFooter>
        <ModalFooterRightGroup>
          <FormButton primary={true} label={`Export`} onClick={this.onExport} />
        </ModalFooterRightGroup>
      </ModalFooter>
    );

    return (
      <ModalView header={modalHeading} footer={modalFooter} fixedHeight={null}>
        <ModalBody>
          {this.props.embeddedAttachments.size ? (
            <ModalGroup label="Attachment Path">
              <ModalDescription>
                <span>
                  Your timeline contains embedded images and/or attachments. These will be saved to /attachments
                  relative to where you save your .tsf file.
                </span>
              </ModalDescription>
              <ModalDescription>
                <span>
                  You may customise the path that is used in the exported standard format file. This is useful if you
                  intend to upload your images/attachments.
                </span>
              </ModalDescription>
              <ModalRow>
                <ModalField>
                  <input
                    type="text"
                    ref={this.inputRef}
                    value={this.state.attachmentPath ? this.state.attachmentPath : ""}
                    onChange={this.onInputChange}
                    disabled={false}
                    placeholder="http://www.domain.com/my-uploaded-folder/images"
                  />
                </ModalField>
              </ModalRow>
              {/* {this.state.attachmentPath ? (
                <ModalRow>
                  <ModalField label="After exporting, upload your attachments to:">
                    <div className="exportTsfPathPreview">
                      {this.state.attachmentPath}
                      {this.state.attachmentPath.substr(-1) === "/" ? "" : "/"}attachments
                    </div>
                  </ModalField>
                </ModalRow>
              ) : null} */}
            </ModalGroup>
          ) : null}
          <ModalGroup label="Theme">
            <ModalDescription>
              <span>Set the default theme for presentation tools that support Aeon Timeline app data.</span>
            </ModalDescription>
            <ModalRow minFieldWidth={true}>
              <ModalField>
                <FormDropdown
                  options={skinOptions}
                  value={this.state.skin}
                  onChange={newState => this.setState({ skin: newState })}
                  title="Theme"
                />
              </ModalField>
            </ModalRow>
          </ModalGroup>
          <ModalGroup label="Viewer capabilities">
            <ModalDescription>
              <span>Disable viewer capabilities for presentation tools that support Aeon Timeline app data.</span>
            </ModalDescription>
            <ModalRow minFieldWidth={true}>
              <ModalField>
                <FormCheckbox
                  checkboxState={this.state.disableTimelineZoom}
                  label={`Prevent adjusting the timeline scale`}
                  onChange={newState => this.setState({ disableTimelineZoom: newState })}
                />
              </ModalField>
            </ModalRow>
            <ModalRow minFieldWidth={true}>
              <ModalField>
                <FormCheckbox
                  checkboxState={this.state.disableFiltering}
                  label={`Hide the Filter sidebar`}
                  onChange={newState => this.setState({ disableFiltering: newState })}
                />
              </ModalField>
            </ModalRow>
            <ModalRow minFieldWidth={true}>
              <ModalField>
                <FormCheckbox
                  checkboxState={!this.state.disableFiltering && this.state.disableFilteringMore}
                  label={`Hide the "More Filters" button`}
                  onChange={newState => this.setState({ disableFilteringMore: newState })}
                  disabled={this.state.disableFiltering}
                />
              </ModalField>
            </ModalRow>
            <ModalRow minFieldWidth={true}>
              <ModalField>
                <FormCheckbox
                  checkboxState={!this.state.disableFiltering && this.state.disableSplitView}
                  label={`Lock the number of split views`}
                  onChange={newState => this.setState({ disableSplitView: newState })}
                  disabled={this.state.disableFiltering}
                />
              </ModalField>
            </ModalRow>
          </ModalGroup>
        </ModalBody>
      </ModalView>
    );
  }
}

ExportTsfModal.propTypes = {
  version: PropTypes.string,
  onCloseClick: PropTypes.func.isRequired,
  onExportClick: PropTypes.func.isRequired,
  embeddedAttachments: ImmutablePropTypes.list.isRequired,
  skin: PropTypes.string.isRequired
};

const mapStateToProps = state => {
  return {
    embeddedAttachments: attachmentSelectors.getEmbeddedAttachments(state.present),
    attachmentsById: attachmentSelectors.getAttachmentsById(state.present),
    skin: preferencesSelectors.getSkin(state.present)
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCloseClick: () => {
      dispatch(uiStateOperations.hideExportTsfModal());
    },
    onExportClick: (
      attachmentPath,
      attachmentIds,
      disableFiltering,
      disableFilteringMore,
      disableSplitView,
      disableTimelineZoom,
      skin
    ) => {
      exportTsfFile(
        attachmentPath,
        attachmentIds,
        disableFiltering,
        disableFilteringMore,
        disableSplitView,
        disableTimelineZoom,
        skin
      );
      dispatch(uiStateOperations.hideExportTsfModal());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportTsfModal);
